<template>
  <div class="statementWrap">
    <div class="content">
      <div class="file-title">文件一</div>
      <div class="title">商标服务确认书</div>
      <p style="text-indent: 2em;">本确认书为深圳麦德通商务技术有限公司（以下简称“麦德通”）与客户之间就商标软件服务合作所达成的一致约定，双方将共同遵守执行：</p>
      <p style="text-indent: 2em;" class="text-decoration">客户应当认真阅读并充分了解本确认书全部内容条款，特别是本确认书中以加租加黑和/或加下划线等显示形式提示注意的重要条款，请客户务必重点查阅。</p>

      <p class="bold">一、服务事项</p>
      <p>1.1.客户购买麦德通平台商标软件产品服务后，麦德通为客户提供相关的商标软件平台服务，包括但不限于商标注册、商标宣誓、商标转让等服务项目。</p>
      <p>1.2.麦德通为客户提供商标软件服务及技术支持，包括但不限于：<span class="text-decoration">为用户提供软件产品使用权，使得用户能够在软件上进行商标起名、核名、提交身份信息和商标注册申请资料、递交申请、进度查询、报告自动获取等软件功能使用，委托具有合格资质的境内外知识产权代理机构或律师审核用户申请资料，并向当地知识产权局递交申请材料等，以及为完成知识产权注册提供相关的销售、服务及技术支持。</span></p>

      <p class="bold">二、关于费用</p>
      <p>2.1  客户支付的费用包括商标代理费（服务费）和商标官费，具体收费金额以麦德通平台提供为准。<span class="text-decoration">其中商标代理费包含麦德通委托具有合格资质的第三方机构或者律师时所产生的律师代理费。</span></p>
      <p>2.2  <span class="bold">关于退款，客户应知晓并同意，如7天内未提交服务资料（系指客户在付款后7天内，未通过麦德通平台递交任何商标案件资料）可申请退款。如超过7天或客户已递交服务资料的，麦德通有权不予退款。商标官费一经缴纳概不退还。</span></p>
      <p class="bold">三、双方权责</p>
      <p>3.1  麦德通负责指导客户提供商标服务所需的全部资料及文件，并将相关资料及文件递交给合作的当地律师或律所进行审核，对不符合商标申请及相关服务要求或规范的，有权要求客户进行修改或补充，客户应给予积极配合。</p>
      <p>3.2  麦德通负责提供专业建议和商标申请服务全流程管理，如涉及特殊复杂案件或特殊资质的，麦德通将咨询境外合作律师或律所提供专业建议，并将意见反馈给客户。但客户应理解并同意，因商标审查具有主观性，商标是否获得核准通过由相关的商标主管机构审查后决定。<span class="text-decoration">麦德通不对客户的商标审查成功率及申请时效做出任何明示或暗示的保证，亦不承担未申请成功后给用户带来的损失及所产生的任何后果。</span></p>
      <p>3.3  <span class="bold">麦德通在收到完整的申请材料及全部费用后，委托具有合格资质的第三方机构或律师向客户委托申请国家商标主管机构进行递交。客户同意授权麦德通作为全权代表，负责跟境外合作律师或律所进行沟通，并将沟通结果同步客户。</span></p>
      <p>3.4  麦德通负责接收并传达商标局等官方机构下发的各项通知或文件（如涉及特殊资质许可的，麦德通负责协助转达），并及时向客户传递委托事项的进展。</p>
      <p>3.5  麦德通将尽可能协助客户在第三方平台的品牌备案，并提供接收到的相应品牌的验证码；但由于客户自身原因或第三方平台政策导致的备案不成功，麦德通不予负责。</p>
      <p>3.6  客户应按照要求配合提供相关资料信息，并确保所提供信息资料的真实性、准确性及完整性。因客户提供资料问题导致申请及相关服务延迟或失败的，麦德通概不负责。</p>
      <p>3.7  客户应及时查阅麦德通所转发的商标局等官方机构下发的各项文件或通知（如涉及特殊资质许可的，麦德通负责协助转达），对于商标申请服务中可能存在的任何补正、答疑、说明等，客户需在规定时限内做出指示或配合。如因未收到客户指示或超过规定时限做出指示或不配合提供资料等，导致客户商标申请部分或全部驳回、失效等后果的，由客户自行承担。</p>
      <p>3.8  客户应知晓商标审查过程中可能遇到官方要求补正/说明/驳回、第三方异议等情况，因此所产生的费用并不包含在本次合同服务费用范围内。</p>
      <p>3.9  客户如发生登记信息变更（包括但不限于公司名称、注册地址等），须及时通知并委托麦德通向所属国家或地区商标主管机关提出变更申请。否则导致的相关部门处罚和罚款等后果，由客户自行承担。</p>
      <p>3.10 <span class="text-decoration bold">为便于更好的为客户提供商标服务，客户应知晓并同意，麦德通将在收集客户“电子签名”后，可能用于商标申请过程中的相关文件签署（例如授权书、官方要求的资料声明协议等），如客户要求电子签名所涉及的具体签署文件，可向麦德通申请查询。</span></p>
      <p>3.11 客户须遵守相关国家法律法规规定及商标注册规则，申请或使用商标不得有违反相关国家商标申请及使用的禁止性要求、违背社会公共利益或社会道德、以及损害他人合法权益的行为。客户应确保商标注册申请的合法合理性，不得有恶意抢注或模仿他人相同或近似商标以及其他侵犯他人在先商标使用权的行为，不得有无使用目的恶意囤积商标行为。因违反上述要求，所导致的商标申请失败、罚款等任何后果由客户自行承担。如因此给麦德通带来损失的，由客户进行赔偿。</p>
      <p>3.12 <span class="bold">客户应及时按照麦德通要求进行申请文件的签署，并保证签名是真实有效的。如因客户未及时签署或签署不真实导致的商标服务项目驳回或失效的，与麦德通无涉。</span></p>
      <p class="bold">四、免责条款</p>
      <p>4.1  因发生不可抗力因素（包括但不限于战争、火灾、地震、洪水、罢工、疫情等）导致本协议项下权利义务无法履行的，遭受不可抗力一方应及时通知对方并提供相关证明，双方互不承担违约责任。</p>
      <p>4.2  鉴于软件产品和互联网服务的特殊性（包括但不限于黑客攻击、网络病毒以及其他不可控制的情形），客户应理解并同意由此造成的服务中断或延迟等损失和后果，麦德通不承担任何责任。</p>
      <p class="bold">五、违约责任</p>
      <p>5.1  本确认书签署后，即产生法律效力。任何一方不得单方面解除合作，否则视为违约。违约方将承担因违约行为所导致的守约方的一切直接经济损失。</p>
      <p>5.2  如因客户原因不配合提供相关材料导致本确认书服务部分或全部无法履行，麦德通不承担任何责任。</p>
      <p>5.3  若因不可抗力或其他不能归咎于双方的原因导致本确认书服务未能履行的，各方均不承担任何违约责任。</p>
      <p class="bold">六、其它事项</p>
      <p>6.1  本确认书自客户签字或盖章之日起生效，自客户回传或扫描上传至麦德通平台后开始执行。</p>
      <p>6.2  凡因执行本确认书所发生的或与本确认书有关的—切争议，双方应通过友好协商解决。如果协商不能解决时，任何—方有权将该争议提交至深圳市南山区人民法院诉讼解决。</p>
      <p>6.3  <span class="bold">客户如同意接受本确认书全部内容，应按照指引完成“电子签名”事宜。此签名将被视为客户真实性意思表达。</span></p>
      <p class="text-right">客户名称：______________</p>
      <p class="text-right">签字/盖章：<span style="visibility: hidden">_____________</span></p>
      <p class="text-right">日期：____年____月____日</p>
      <div class="file-title file-title2">文件二</div>
      <div class="title">个人信息处理授权书</div>
      <p style="text-indent: 2em;">因本人办理{{ serviceName }}（简称“委托事项”）之所需，本人作为权利人，本人之个人信息（简称“受托个人信息”）需要根据委托事项所涉及的国家/地区的法律法规及监管要求，用于提交至境外监管机构或相关的境外第三方机构。</p>
      <p style="text-indent: 2em;">现本人委托代理人（简称“授权代理人”，手机号：{{ $route.query.phone }}），代表本人办理委托事项所涉及个人信息处理之事宜，现就授权事项，本人特此声明如下：</p>
      <p>1.本人知悉并进一步同意，授权代理人为办理委托事项所必需，可以委托专业服务机构处理受托个人信息，且无需另行获得本人的授权同意。</p>
      <p>2.本人知悉并进一步同意，为完成委托事项之目的，受托个人信息可被提交至境外监管机构或相关的境外第三方机构。</p>
      <p>3.本人知悉并进一步确认，本声明所载受托个人信息包括本人身份证明材料（身份证明材料包括身份证、护照或其他具有法定效力的证明材料）以及身份证明材料中所涉及的其他元素；签字；联系方式或根据监管机构要求需要提供的其他个人信息材料等。</p>
      <p>4.本人知悉并进一步确认，授权代理人以及授权代理人所委托的专业服务机构为办理委托事项所需要，将受托个人信息按照委托事项所适用的相关法律法规的要求传输至中国境外，并未侵害本人的合法权益。</p>
      <p>5.本人知悉并进一步确认，本授权书所载针对本人个人信息处理活动仅适用于办理委托事项，授权代理人为办理其他事项所涉及的本人的个人信息处理活动不适用于本授权书。</p>
      <p>6.本人知悉并进一步确认，为办理委托事项所必需，如专业服务机构需要将受托个人信息进一步转委托至他人处理的，专业服务机构无需获得本人的另行单独同意。</p>
      <p>7.本授权书所在授权事项的授权期限自本授权书作出之日至委托事项全部办理完毕为止。</p>
      <p>8.本人知悉并进一步确认，本声明由本人自愿、明确做出，授权代理人应当严格按照本授权书所载权限，针对委托事项处理本人的个人信息。</p>
      <p>以上，</p>
      <p>特此授权。</p>
      <p class="text-right">签字：<span style="visibility: hidden">____年____月____日</span></p>
      <p class="text-right">日期：____年____月____日</p>
    </div>
    <div class="bottom" @click="toSign">{{number == 0 ? '完成阅读' : `请阅读协议（倒计时：${number}）` }}</div>
  </div>
</template>
<script>
import { COMMON_COUNTRY, COMMON_SERVICE_TYPE } from '@ost/static'
export default {
  data () {
    return {
      number: 5
    }
  },
  created () {
    document.documentElement.scrollTop = 0
    document.title = '麦德通'
    let timer = setInterval(() => {
      if (this.number === 0) {
        window.clearInterval(timer)
      } else {
        this.number = this.number - 1
      }
    }, 1000)


    if (process.env.NODE_ENV != 'production') {
      this.number = 1
    }
  },
  computed: {
    serviceName() {
      const { country, serviceType } = this.$route.query
      return `${COMMON_COUNTRY.getValueToLabel(country + '') || ''}${COMMON_SERVICE_TYPE.getValueToLabel(serviceType + '') || ''}`
    }
  },
  methods: {
    toSign () {
      if (this.number !== 0) {
        return
      }
      this.$router.push({
        name: 'sign',
        query: {
          applyIdKey: this.$route.query.applyIdKey
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.statementWrap {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  overflow-y: hidden;
  text-align: left;

  .content {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
  }

  .bottom {
    height: 50px;
    background: #1363F7;
    text-align: center;
    line-height: 50px;
    color: #fff;
  }
}

.file-title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: #333;
  line-height: 22px;
  text-align: left;
  margin-bottom: 20px;
}

.file-title2 {
  margin-top: 100px;
}

.title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: #333;
  line-height: 22px;
  text-align: center;
  margin-bottom: 20px;
}

.bold {
  font-weight: bold;
}

.text-right {
  text-align: right;
}

.text-decoration {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/statement.vue